import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import type { SxProps } from '@mui/material/styles';
import { BRAND_ICON_URL_MAP } from './constants';
import type { BrandIconName } from './types';
type BrandIconProps = {
  name: BrandIconName;
  size: number;
  svgStyles?: SxProps;
};
export function BrandIcon(t0) {
  const $ = _c(6);
  const {
    name,
    size,
    svgStyles: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const svgStyles = t2;
  const t3 = BRAND_ICON_URL_MAP[name];
  let t4;
  if ($[2] !== size || $[3] !== svgStyles || $[4] !== t3) {
    t4 = <Box width={size} height={size} component="img" src={t3} loading="lazy" aria-hidden={true} sx={svgStyles} />;
    $[2] = size;
    $[3] = svgStyles;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}